<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark v-if="!showFilters">
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de obras</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right v-if="!showFilters">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="!roles_tecnico.includes(rol)"
                    fab
                    :to="{ path: `/guardar-orden` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
                <div style="display: flex" v-else>
                    <v-btn
                        fab
                        @click="AddOrdenEmpleado"
                        :loading="isloading"
                        :disabled="isloading"
                        color="orange darken-1"
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-account-plus-outline</v-icon
                        >
                    </v-btn>
                    <v-text-field
                        label="Número de obra"
                        v-model="nro_orden"
                        style="margin-left: 1rem"
                    >
                    </v-text-field>
                </div>
            </template>
            <span>Nueva obra</span>
        </v-tooltip>
        <v-row v-if="!showFilters">
            <!-- <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col> -->

            <v-col cols="12" md="8">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>

            <v-col cols="12" md="4">
                <v-btn
                    color="primary"
                    class="white--text mr-2"
                    @click="
                        () => {
                            page = 1;
                            getOrdenes();
                        }
                    "
                >
                    Filtrar
                </v-btn>
                <v-btn
                    color="red"
                    class="white--text"
                    @click="
                        filtros = {};
                        filtros_prueba = {};
                        getOrdenes();
                    "
                >
                    Limpiar filtros
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="roles_tecnico.includes(rol) ? headers_no : headers"
            :items="Ordenes"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            :item-class="ColorEstado"
            @click:row="
                (item) => {
                    OpenOrdenInNextWindow(item);
                }
            "
            :server-items-length="total_orden_trabajo"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.orden_relacionada="{ item }">
                <template v-if="item.orden_relacionada.length > 0">
                    <div
                        v-for="(orden, index) in item.orden_relacionada"
                        :key="index"
                    >
                        <template v-if="orden.orden != null">
                            {{ orden.orden.nro_orden }},
                        </template>
                    </div>
                </template>
            </template>
            <template v-slot:item.elevacion="{ item }">
                <template v-if="item.elevacion == 1">
                    <v-icon color="green" small class="mr-2"
                        >mdi-check-bold</v-icon
                    ></template
                >
            </template>
            <template v-slot:item.instalacion_electrica="{ item }">
                <template v-if="item.instalacion_electrica == 1">
                    <v-icon color="green" small class="mr-2"
                        >mdi-check-bold</v-icon
                    ></template
                >
            </template>
            <template v-slot:item.created_at="{ item }">
                <span>{{ item.created_at | format_date }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a
                    target="_blank"
                    :href="`/api/pdf-orden/${item.id}`"
                    @click.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
            <template v-slot:item.pdf_albaran="{ item }">
                <a
                    target="_blank"
                    :href="`/api/pdf-albaran-ventas/${item.id}`"
                    v-if="item.pdf_albaran != null"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF Albarán"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
            <template v-slot:item.consumo="{ item }">
                <v-icon
                    @click="
                        orden = item;
                        dialog_consumo = true;
                    "
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="PDF"
                    >mdi-chef-hat</v-icon
                >
            </template>
            <template v-slot:item.timer="{ item }">
                <template v-if="item.fichajes != null && item.id_estado != 4">
                    <div
                        v-if="item.fichajes.length % 2 == 0"
                        @click="Fichar(item, false)"
                        class="round"
                        style="background-color: green"
                    >
                        <v-icon class="white--text">mdi-play</v-icon>
                    </div>
                    <div style="display: flex" v-else>
                        <div
                            @click="Fichar(item, false)"
                            class="round"
                            style="background-color: orange"
                        >
                            <v-icon class="white--text">mdi-pause</v-icon>
                        </div>
                        <div
                            @click="Fichar(item, true)"
                            class="round"
                            style="background-color: red"
                        >
                            <v-icon class="white--text">mdi-stop</v-icon>
                        </div>
                    </div>
                </template>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click.stop="
                        () => {
                            plan_dialog = true;
                            id_orden = item.id;
                        }
                    "
                    small
                    class="mr-2 pointer"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="PLANIFICACIÓN"
                    >mdi-calendar-month</v-icon
                >
                <!--router-link
                    :to="{ path: `/guardar-orden?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </!--router-link-->
                <v-icon
                    @click.stop="openDeleteModal(item.id)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >

                <!--v-icon @click="openModal(item)" small class="mr-2" color="red" style="font-size: 25px;" title="BORRAR">mdi-trash-can</!--v-icon-->
            </template>
        </v-data-table>
        <v-dialog v-model="plan_dialog" max-width="1000px">
            <FormPlan v-model="id_orden"></FormPlan
        ></v-dialog>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteOrden()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_consumo">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Listado de consumos
                </v-card-title>
                <v-card-text style="text-align: center">
                    <FormOrdenConsumo v-model="orden"></FormOrdenConsumo>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_consumo = false;
                            orden = {};
                        "
                        >Cerrar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<style>
.round {
    border-radius: 10000px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.Back-Yellow {
    background-color: rgb(255, 243, 132);
}
.Back-Green {
    background-color: rgba(158, 255, 158, 0.582);
}
.Back-Orange {
    background-color: rgb(248, 182, 60);
}
.Back-Blue {
    background-color: rgb(93, 173, 248);
}
.Back-Brown {
    background-color: rgba(80, 56, 56, 0.411);
}
</style>
<script>
import FormOrdenConsumo from "./FormOrdenConsumo.vue";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import FormPlan from "./FormPlan.vue";
export default {
    props: ["id_presupuesto", "showFilters"],
    components: {
        FormOrdenConsumo,
        FilterComponentVue,
        FormPlan,
    },
    data() {
        return {
            total_orden_trabajo: 0,
            page: 1,
            cantidad: 15,
            id_orden: null,
            plan_dialog: false,
            dialog_consumo: false,
            nro_orden: null,
            roles_tecnico: ["6", "7", "11"],
            search: "",
            dialog: false,
            id: null,
            /*
            Nombre cliente - Comercial - Población - Elevación -  Instalación electrica - Prioridad (tenemos que ver) - Tiempo estimado (horas) - Pvp sin Iva - Obseraciones - Descripcoón
            */
            headers: [
                { text: "Nº Obra", value: "nro_orden", sortable: false },
                { text: "Nombre", value: "nombre", sortable: false },
                /*{
                    text: "Nº Obra relacionada",
                    value: "orden_relacionada",
                    sortable: false,
                },*/

                { text: "Fecha", value: "created_at", sortable: false },
                {
                    text: "Nombre del cliente",
                    value: "cliente.nombre_comercial",
                    sortable: false,
                },
                {
                    text: "Comercial",
                    value: "cliente.agentes_str",
                    sortable: false,
                },
                {
                    text: "Población",
                    value: "cliente.direccion.ciudad",
                    sortable: false,
                },
                /*{
                    text: "Elevación",
                    value: "elevacion",
                    sortable: false,
                },
                {
                    text: "Instalación eléctrica",
                    value: "instalacion_electrica",
                    sortable: false,
                },
                { text: "Prioridad", value: "prioridad", sortable: false },*/
                { text: "Tiempo estimado", value: "hora", sortable: false },
                { text: "PVP sin IVA", value: "pvp", sortable: false },
                {
                    text: "Observaciones",
                    value: "observaciones",
                    sortable: false,
                },
                { text: "Descripción", value: "descripcion", sortable: false },

                // { text: "PDF Albarán", value: "pdf_albaran", sortable: false },
                { text: "PDF", value: "pdf", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
            headers_no: [
                { text: "Nº Obra", value: "nro_orden", sortable: false },
                /*{ text: "Horas", value: "hora", sortable: false },
                {
                    text: "Horas realizadas",
                    value: "horas_realizadas",
                    sortable: false,
                },*/
                { text: "Audio", value: "timer", sortable: false },

                { text: "Consumo", value: "consumo", sortable: false },
            ],
            Ordenes: [],
            selectedItem: 0,
            dialog: false,
            orden: {},

            filtros_prueba: {},
            filter_headers: [
                {
                    title: "Obra",
                    type: "select",
                    active: false,
                    model: "id_orden",
                    item_text: "nro_orden",
                    item_value: "id",
                },
                /*{
                    title: "Tipo",
                    type: "select",
                    active: false,
                    model: "tipo",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "nombre",
                    item_value: "id",
                },*/
            ],
        };
    },
    created() {
        this.getOrdenes();
        // this.getEstadosOrden();
        // this.getTiposOrden();
    },
    methods: {
        OpenOrdenInNextWindow(item) {
            //this.$router.push(`/guardar-orden?id=${item.id}`);
            window.open(`/#/guardar-orden?id=${item.id}`, "_blank");
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getOrdenes();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getOrdenes();
        },
        ColorEstado(item) {
            let res = "pointer ";
            if (item.pedidos_pendientes == 0) {
                res += "Back-Green";
            } else if (item.id_estado == 2 || item.id_estado == 3) {
                res += "Back-Yellow";
            } else if (item.id_estado == 4) {
                res += "Back-Green";
            } else if (item.id_estado == 5) {
                res += "Back-Orange";
            } else if (item.id_estado == 6) {
                res += "Back-Blue";
            } else if (item.id_estado == 7) {
                res += "Back-Brown";
            }
            return res;
        },
        Fichar(item, detener) {
            axios
                .post(`api/fichar-orden/${item.id}`, {
                    detener: detener,
                })
                .then(
                    (res) => {
                        item.fichajes = res.data.ordenes;
                        item.horas_realizadas = res.data.horas;
                        item.id_estado = res.data.estado;
                    },
                    (res) => {}
                );
        },
        openDeleteModal(id) {
            this.dialog = true;
            this.id = id;
        },
        AddOrdenEmpleado() {
            axios
                .post(`api/add-orden-empleado`, { nro_orden: this.nro_orden })
                .then(
                    (res) => {
                        this.getOrdenes();
                    },
                    (res) => {}
                );
        },
        deleteOrden() {
            axios.get(`api/delete-orden/${this.id}`).then(
                (res) => {
                    this.getOrdenes();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        getOrdenes() {
            this.loading = true;
            let filtros = this.filterString;
            axios
                .get(
                    `api/get-ordenes?page=${this.page}&amount=${this.cantidad}${filtros}`
                )
                .then(
                    (res) => {
                        //console.log(res.data.users);
                        this.Ordenes = res.data.data;
                        this.total_orden_trabajo = res.data.total;
                        //this.filter_headers[0].items = res.data.data;

                        //console.log(this.Ordenes);
                    },
                    (err) => {
                        this.$custom_error("Error consultando las órdenes");
                    }
                );
        },

        openModal(item) {
            this.selectedItem = this.Ordenes.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-orden", {
                    id: this.Ordenes[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Obra eliminada con éxito");
                        this.dialog = false;
                        this.getOrdenes();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando la obra");
                    }
                );
        },

        // En desuso
        /*getEstadosOrden() {
            axios.get(`api/get-estados-orden`).then(
                (res) => {
                    this.filter_headers[2].items = res.data;
                },
                (res) => {}
            );
        },
        getTiposOrden() {
            axios.get(`api/get-tipos-orden`).then(
                (res) => {
                    this.filter_headers[1].items = res.data;
                },
                (res) => {}
            );
        },*/
    },
    computed: {
        rol: function () {
            let rol = localStorage.getItem("role");
            console.log(rol);
            return rol;
        },
        isloading: function () {
            // return this.$store.getters.getloading
        },
        filterString() {
            let filtros = "";

            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }

            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (
                        (this.filtros_prueba[head.model].value != "" &&
                            this.filtros_prueba[head.model].value != null) ||
                        (this.filtros_prueba[head.model].nombre != "" &&
                            this.filtros_prueba[head.model].nombre != null)
                    ) {
                        filtros += `&${head.model}=${
                            this.filtros_prueba[head.model].value
                        }`;
                    }
                }
            });
            if (this.id_presupuesto) {
                filtros += `&id_presupuesto=${this.id_presupuesto}`;
            }
            return filtros;
        },
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: function (val) {
                //console.log(val);
            },
        },
    },
};
</script>
